import React from 'react';
import {DesktopPage} from '../../../clean-components/desktop-page/desktop-page';
import {CloseMarkers} from '../../../clean-components/close-markers/close-markers';

export const CloseServicesDesktop = () => {
    return <DesktopPage>
        <CloseMarkers/>
    </DesktopPage>;
};
